import React, {useState} from 'react';
import HowToUseApp from './API/howToUse';

const Aboutus = () => {

const [aboutData, setAboutData] = useState(HowToUseApp);
    return(
        <>
            <section className='common-section our-services'>
                <div className='container mb-5'>
                    <div className='row'>
                        <div className='col-12 col-lg-5 text-center our-service-leftside-img'>
                            <img src='./images/use.jpg' alt='service image' />
                        </div>
                        <div className='col-12 col-lg-7 our-services-list'>
                            <h3 className='mini-title'>-- Available @ Google and Ios app store only</h3>
                            <h1 className='main-heading'>How to use the app</h1>
                            { aboutData.map((curElem) => {
                                const {id, title, info } = curElem;
                                return (
                                    <>
                                        <div className='row our-services-info' key={id}>
                                            <div className='col-1 our-services-number'>{id}</div>
                                            <div className='col-10 our-services-data'>
                                                <h2>{title}</h2>
                                                <p className='main-hero-para'>
                                                    {info}
                                                </p>
                                            </div>
                                        </div>
                                    </>
                                );
                            })}
                            
                            <br />
                            <button className='btn-style btn-style-border'>learn more</button>
                        </div>
                    </div>
                </div>
            </section>

            {/* second about us section  */}
            <section className='common-section our-services-rightside'>
                <div className='container mb-5'>
                    <div className='row'>
                        <div className='col-12 col-lg-7 our-services-rightside-content d-flex justify-content-center align-items-start flex-column'>
                            <h3 className='mini-title'>-- SUPPORT IN ANY LANGUAGE</h3>
                            <h1 className='main-heading'>World class support is <br />available 24/7</h1>
                            { aboutData.map((curElem) => {
                                const {id, title, info } = curElem;
                                return (
                                    <>
                                        <div className='row our-services-info' key={id}>
                                            <div className='col-1 our-services-number'>{id}</div>
                                            <div className='col-10 our-services-data'>
                                                <h2>{title}</h2>
                                                <p className='main-hero-para'>
                                                    {info}
                                                </p>
                                            </div>
                                        </div>
                                    </>
                                );
                            })}
                            
                            <br />
                            <button className='btn-style btn-style-border'>learn more</button>
                        </div>
                        <div className='col-12 col-lg-5 our-service-rightside-img'>
                            <img src='./images/digital.png' className='img-fluid' alt='service image' />
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Aboutus;